import { Box } from '@careguide/theme'
import React from 'react'
import LayoutDesktop from '../Layout/Desktop'
import LayoutMobile from '../Layout/Mobile'
import { NavDesktopLoggedIn } from './ContentDesktop'
import { NavMobileLoggedIn } from './ContentMobile'

export type LoggedInContentProps = {
  viewer: TODO
  showUpgradeCta: boolean
}

export const LoggedInContent = ({ viewer, showUpgradeCta }: LoggedInContentProps) => {
  const loggedInLinks = viewer.navigation?.navigationItems
  const myProfileTitle = viewer.dropDown?.title
  const myProfileLinks = viewer.dropDown?.navigationItems
  const unreadMessageCount = viewer.user?.unreadMessagesCount ?? 0

  return (
    <>
      <Box display={{ _: 'none', desktop: 'block' }} width={{ _: '0', desktop: '100%' }}>
        <LayoutDesktop>
          <NavDesktopLoggedIn
            links={loggedInLinks}
            myProfileTitle={myProfileTitle}
            myProfileItems={myProfileLinks}
            showUpgradeCta={showUpgradeCta}
            unreadMessageCount={unreadMessageCount}
          />
        </LayoutDesktop>
      </Box>
      <Box display={{ _: 'block', desktop: 'none' }} width={{ desktop: '0', _: '100%' }}>
        <LayoutMobile showUpgradeCta={showUpgradeCta}>
          <NavMobileLoggedIn
            topNavItems={loggedInLinks}
            bottomNavItems={myProfileLinks}
            unreadMessageCount={unreadMessageCount}
          />
        </LayoutMobile>
      </Box>
    </>
  )
}
